import PosthogService from '~/services/posthog/PosthogService';

export interface IShiftCancellationReasonSubmittedPayload {
  officeId: string;
  shiftId: string;
  reason: string;
  othersReason: string;
}

/**
 * Fires when an office submits a cancellation reason for a shift
 * Event: office:shift:shift_cancellation_reason_submitted
 */
export function fireShiftCancellationReasonSubmitted(
  payload: IShiftCancellationReasonSubmittedPayload,
): void {
  PosthogService.getInstance().track(
    'office:shift:shift_cancellation_reason_submitted',
    {
      officeId: payload.officeId,
      shiftId: payload.shiftId,
      reason: payload.reason,
      othersReason: payload.othersReason,
    },
  );
}
